import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-gutter-md" }
const _hoisted_2 = { class: "q-gutter-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_PhoneInput = _resolveComponent("PhoneInput")!
  const _component_date_picker = _resolveComponent("date-picker")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_async_btn = _resolveComponent("async-btn")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: _ctx.title,
    size: "xs",
    ref: "modal"
  }, {
    actions: _withCtx(() => [
      _createVNode(_component_async_btn, {
        label: "Save",
        color: "primary",
        task: _ctx.task,
        onClick: _ctx.save
      }, null, 8, ["task", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_q_tabs, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
        dense: "",
        class: "text-grey",
        "active-color": "primary",
        "indicator-color": "primary",
        align: "justify",
        "narrow-indicator": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab, {
            name: "personal",
            label: "Personal"
          }),
          _createVNode(_component_q_tab, {
            name: "file",
            label: "File"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_q_separator),
      _createVNode(_component_q_tab_panels, {
        modelValue: _ctx.tab,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.tab) = $event)),
        animated: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_tab_panel, { name: "personal" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_input, {
                  label: "First Name",
                  modelValue: _ctx.client.firstName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.client.firstName) = $event)),
                  outlined: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_component_q_input, {
                  label: "Last Name",
                  modelValue: _ctx.client.lastName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.client.lastName) = $event)),
                  outlined: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_component_q_input, {
                  label: "Email",
                  type: "email",
                  modelValue: _ctx.client.email,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.client.email) = $event)),
                  outlined: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_component_PhoneInput, {
                  label: "Phone",
                  modelValue: _ctx.client.phone,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.client.phone) = $event)),
                  outlined: "",
                  required: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_component_date_picker, {
                  label: "Date of Birth",
                  modelValue: _ctx.client.dateOfBirth,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.client.dateOfBirth) = $event)),
                  outlined: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_q_tab_panel, { name: "file" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_q_input, {
                  label: "File Reference Number",
                  modelValue: _ctx.client.fileRefNo,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.client.fileRefNo) = $event)),
                  outlined: ""
                }, null, 8, ["modelValue"]),
                _createVNode(_component_date_picker, {
                  label: "Date of Loss",
                  modelValue: _ctx.client.dateOfLoss,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.client.dateOfLoss) = $event)),
                  outlined: ""
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }, 8, ["title"]))
}